import CloseOutlined from "@mui/icons-material/CloseOutlined";
import DownloadOutlined from "@mui/icons-material/DownloadOutlined";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

const MIME_BY_EXTENSION = {
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
  svg: "image/svg+xml",
  txt: "text/plain",
  csv: "text/csv",
};

const getContentType = ({ blob, name, contentType }) => {
  const declaredType = (contentType || "").split(";")[0].toLowerCase();
  const blobType = (blob.type || "").split(";")[0].toLowerCase();
  if (declaredType && declaredType !== "application/octet-stream") return declaredType;
  if (blobType && blobType !== "application/octet-stream") return blobType;
  return MIME_BY_EXTENSION[name?.split(".").pop()?.toLowerCase()] || declaredType || blobType;
};

const MhdFilePreviewDialog = ({ file, onClose }) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!file?.blob) return undefined;
    const previewBlob = new Blob([file.blob], { type: getContentType(file) });
    const objectUrl = URL.createObjectURL(previewBlob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  if (!file) return null;

  const name = file.name || "Αρχείο";
  const contentType = getContentType({ ...file, name });
  const isImage = contentType.startsWith("image/");
  const isDocument = contentType === "application/pdf" || contentType === "text/plain" || contentType === "text/csv";

  const handleDownload = () => {
    if (!url) return;
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = name;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="lg" aria-labelledby="mhd-file-preview-title">
      <DialogTitle id="mhd-file-preview-title" sx={{ pr: 7, overflowWrap: "anywhere" }}>
        {name}
        <IconButton aria-label="Κλείσιμο προεπισκόπησης" onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
          <CloseOutlined />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 1.5, minHeight: { xs: 280, sm: 420 } }}>
        {url && isImage && (
          <Box component="img" src={url} alt={name} sx={{ display: "block", maxWidth: "100%", maxHeight: "75vh", mx: "auto" }} />
        )}
        {url && isDocument && (
          <Box component="iframe" src={url} title={name} sx={{ width: "100%", height: "75vh", border: 0, display: "block" }} />
        )}
        {!isImage && !isDocument && (
          <Typography variant="body2" color="text.secondary">
            Δεν είναι διαθέσιμη η προεπισκόπηση αυτού του τύπου αρχείου. Μπορείτε να το κατεβάσετε.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2 }}>
        <Button onClick={onClose}>Κλείσιμο</Button>
        <Button onClick={handleDownload} disabled={!url} startIcon={<DownloadOutlined />}>
          Λήψη
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MhdFilePreviewDialog;
